import routes from './routes'

export { routes }



// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/index.js